<div [formGroup]="form" [hidden]="isHidden">
    <mat-form-field class="cp-input cp-combobox se-form-field" appearance="outline">
        <mat-label *ngIf="control.isWithLabel">{{ control.name }}</mat-label>

        <mat-select
            *ngIf="!control.isDynamicDataSource"
            [title]="getComponentTooltipText()"
            [errorStateMatcher]="errorStateMatcher"
            [compareWith]="compareItems"
            [formControlName]="control.id"
            [multiple]="control.isMultiple"
            [placeholder]="control.isWithLabel ? control.name : ''"
            (focus)="onFocus()"
        >
            <mat-option *ngIf="control.isWithLabelOnTop" disabled>
                {{ control.name }}
            </mat-option>

            <mat-option *ngIf="control.hasFilter && (hasManyOptions$ | async)">
                <ngx-mat-select-search
                    noEntriesFoundLabel="{{ 'NoResults' | translate }}"
                    placeholderLabel="{{ 'Search' | translate }}"
                    [ngModel]="comboboxFilter$ | async"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onFilter($event)"
                ></ngx-mat-select-search>
            </mat-option>

            <mat-option
                *ngFor="let option of dataSource$ | async"
                [title]="getOptionDescription(option)"
                [value]="option"
            >
                {{ getOptionDescription(option) }}
            </mat-option>

            <mat-select-trigger [title]="getTriggerTooltipText()">
                {{ getTriggerText() }}
            </mat-select-trigger>
        </mat-select>

        <mat-select
            *ngIf="control.isDynamicDataSource"
            [title]="getComponentTooltipText()"
            [errorStateMatcher]="errorStateMatcher"
            [compareWith]="compareDynamicItems"
            [formControlName]="control.id"
            [multiple]="control.isMultiple"
            [placeholder]="control.isWithLabel ? control.name : ''"
            (focus)="onFocus()"
        >
            <mat-option *ngIf="control.isWithLabelOnTop" disabled>
                {{ control.name }}
            </mat-option>

            <mat-option *ngIf="control.hasFilter && (hasManyOptions$ | async)">
                <ngx-mat-select-search
                    noEntriesFoundLabel="{{ 'NoResults' | translate }}"
                    placeholderLabel="{{ 'Search' | translate }}"
                    [ngModel]="comboboxFilter$ | async"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onFilter($event)"
                ></ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let option of dynamicDataSource$ | async" [title]="option.value" [value]="option.id">
                {{ option.value }}
            </mat-option>
        </mat-select>

        <button
            mat-icon-button
            matSuffix
            class="se-button-no-ripple"
            *ngIf="!isDisabled && !control.readonly && !control.required"
            (click)="onReset($event)"
        >
            <mat-icon> close </mat-icon>
        </button>

        <button mat-icon-button matSuffix class="se-button-no-ripple" *ngIf="control.icon" [title]="control.tooltip">
            <mat-icon>
                {{ control.icon }}
            </mat-icon>
        </button>

        <mat-hint></mat-hint>
    </mat-form-field>
</div>
